/* eslint-disable */
/**
 * The path of the `ErrorPage` to be consumed by a `<Router />`
 * @export
 */
export const ERROR_PAGE_PATH = `/error`;

/**
 * Create a `href` that will resolve to `ErrorPage`
 * @export
 * @returns {string} The `ERROR_PAGE_PATH`
 */
export const createErrorPageLink = () => ERROR_PAGE_PATH;

/**
 * Determine if the current page is the `ErrorPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `ErrorPage`
 */
export const isErrorPage = (match) => match.path === ERROR_PAGE_PATH;
